
























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IJob } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'WorkflowJobItem',

  props: {
    index: {
      type: Number,
      default: -1,
    },
    job: {
      type: Object as () => IJob,
      required: true,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    showDrag: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isSample: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    focusOnCreate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ColorAssistant,
      TextAssistant,
    }
  },

  created() {
    if (this.focusOnCreate) {
      this.$nextTick(() => {
        // @ts-ignore
        this.$refs.nameInput.focus()
      })
    }
  },

  methods: {
    handleDeleteClick(index: number) {
      if (!this.showDelete) {
        return
      }
      this.$emit('delete-clicked', index)
    },
  },
})
